// import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
import Parse from "parse";
const Request = require("request").defaults({ encoding: null });

const GetPromisedData = (url) =>
  new Promise((resolve, reject) => {
    Request(url, function (error, response, body) {
      if (error || !response) {
        reject(error);
      }
      if (response && response.statusCode !== 200) {
        reject(body);
      }
      if (!error && response.statusCode === 200) {
        let ImageData = new Buffer(body).toString("base64");
        resolve(ImageData);
      }
    });
  });

export default ({ URL, APP_ID, JAVASCRIPT_KEY }) => {
  // const redirect = useRedirect()
  if (Parse.applicationId === null || Parse.javaScriptKey === null) {
    Parse.initialize(APP_ID, JAVASCRIPT_KEY);
    Parse.serverURL = URL;
  }
  return {
    login: async ({ username, password, redirect, userInfo, notify }) => {
      try {
        const user = await Parse.User.logIn(username, password);
        const User = {
          id: user.id,
          ...user.attributes,
        };
        localStorage.setItem("permissions", user.attributes.sessionToken);
        localStorage.setItem("session", user.attributes.sessionToken);
        localStorage.setItem("user", user.id);
        if (User) {
          if (User.OptIn) {
            userInfo ? redirect("/user-info") : redirect("/");
            // notify("Please Complete WhatsApp Onboarding Process");
            // window.open(
            //   "https://signupforservices.com/whatsapp/optin/?bId=ee50664e-2c0d-460c-b0ad-469acf3286c0&bName=RijwanApp1&s=URL&lang=en_US",
            //   "_blank"
            // );
          } else {
            userInfo ? redirect("/user-info") : redirect("/");
            // notify("Please Complete WhatsApp Onboarding Process");
            // window.open(
            //   "https://signupforservices.com/whatsapp/optin/?bId=1b8cf488-eca2-436f-bd0a-dd348b6cb828&bName=123mentordeveloper&s=URL&lang=en_US",
            //   "_blank"
            // );
          }
        } else {
          throw new Error("Wrong Username/Password");
        }
      } catch (error) {
        console.log("error", error);
        throw error;
        // Error("Wrong username / password");
      }
    },

    logout: async () => {
      try {
        await Parse.User.logOut();
        return Promise.resolve();
      } catch (error) {
        throw Error(error.toString());
      }
    },
    checkError: (error) => {
      return Promise.resolve();
    },
    checkAuth: () => {
      return Parse.User.current() ? Promise.resolve() : Promise.reject();
    },
    getPermissions: async () => {
      const UserPermission = Parse.User.current();

      return {
        role: UserPermission.get("role"),
        isMentor: UserPermission.get("isMentor"),
      };
    },
    resetPassword: async ({ email, redirect, notify }) => {
      try {
        await Parse.User.requestPasswordReset(email);
        redirect("/login");
        notify(" Reset Email sent to your Email");
      } catch (e) {}
    },
    signUp: async (payload) => {
      const { email, mobileNo, profileImage, name, Password } = payload;
      try {
        var user = new Parse.User();
        user.set("username", email);
        user.set("email", email);
        user.set("email_", email);
        user.set("mobileNo", mobileNo);
        if (profileImage) {
          user.set("profileImage", profileImage);
        }

        user.set("password", Password);
        user.set("name", name);

        const response = await user.signUp();

        return JSON.stringify(response);
      } catch (e) {
        console.log("e", e);
        return JSON.stringify({
          code: 202,
          message: "Email already exists please try a new email id",
        });
      }
    },
    signUpGoogle: async ({ payload, notify }) => {
      const usrCls = Parse.Object.extend("_User");
      const usrQry = new Parse.Query(usrCls);
      usrQry.equalTo("email", String(payload.profileObj.email));
      await usrQry.first();
      const usrCnt = await usrQry.count();
      if (usrCnt > 0) {
        notify("Your Account already exists kindly login.");
      } else {
        let options = {
          url: payload.profileObj.imageUrl,
          headers: {
            accept: "*/*",
          },
        };

        const base64data = await GetPromisedData(options);

        let File = new Parse.File("image.png", {
          base64: base64data,
        });
        const Result = await File.save();

        const authData = {
          authData: {
            id: payload.profileObj.googleId,
            id_token: payload.tokenObj.id_token,
            access_token: payload.tokenObj.access_token,
          },
        };

        const user = await new Parse.User().linkWith("google", authData);
        user.set("email", payload.profileObj.email);
        user.set("email_", payload.profileObj.email);
        user.set("username", payload.profileObj.email);
        user.set("name", payload.profileObj.name);
        user.set("profileImage", Result);

        await user.save();
      }
    },

    loginGoogle: async ({ payload, redirect, notify }) => {
      /* Check if the user already exists */
      const usrCls = Parse.Object.extend("_User");
      const usrQry = new Parse.Query(usrCls);
      usrQry.equalTo("email", String(payload.profileObj.email));
      await usrQry.first();
      const usrCnt = await usrQry.count();
      if (usrCnt === 0) {
        redirect("/v2/signup");
        notify("Kindly Sign Up");
      } else {
        const authData = {
          authData: {
            id: payload.profileObj.googleId,
            id_token: payload.tokenObj.id_token,
            access_token: payload.tokenObj.access_token,
          },
        };

        const user = await Parse.User.logInWith("google", authData);
        const GoogleUser = {
          id: user.id,
          ...user.attributes,
        };
        localStorage.setItem("permissions", user.attributes.sessionToken);
        localStorage.setItem("user", user.id);

        user.set("email", payload.profileObj.email);
        user.set("username", payload.profileObj.email);
        user.set("name", payload.profileObj.name);
        user.set("isMentor", payload.profileObj.isMentor);

        if (GoogleUser.OptIn) {
          return redirect("/");
        } else {
          // notify("Please Complete WhatsApp Onboarding Process");
          // window.open(
          //   "https://signupforservices.com/whatsapp/optin/?bId=a4a6300a-3049-4f05-859a-bff1ff3a9dad&bName=123Mentor&s=URL&lang=en_US",
          //   "_blank",
          //   "width=800,height=400,marginTop=10"
          // );

          return redirect("/");
        }
      }
    },
    loginLinkedIn: async ({ code, redirect, notify }) => {
      const response = await Parse.Cloud.run("getlinkedinauthtoken", {
        code: code,
        redirect_uri: window.location.origin + window.location.pathname,
      });

      if (response.error) {
        alert("Error getting Access Token");
      }

      const authData = {
        authData: {
          id: response.id,
          access_token: response.access_token,
        },
      };

      /* Check if the user already exists */
      const usrCls = Parse.Object.extend("_User");
      const usrQry = new Parse.Query(usrCls);
      usrQry.equalTo("linkedinUniqueId", String(response.id));

      await usrQry.first();
      const usrCnt = await usrQry.count();

      if (usrCnt === 0) {
        alert("Account does not exist. Kindly Sign Up");
        redirect("/v2/signup");
      } else {
        const user = await Parse.User.logInWith("linkedin", authData);
        localStorage.setItem("user", user.id);
        redirect("/");
        // window.open(
        //   "https://signupforservices.com/whatsapp/optin/?bId=a4a6300a-3049-4f05-859a-bff1ff3a9dad&bName=123Mentor&s=URL&lang=en_US",
        //   "_blank",
        //   "width=800,height=400,marginTop=10"
        // );
      }
    },
    signUpLinkedIn: async ({ code, redirect, notify }) => {
      const response = await Parse.Cloud.run("getlinkedinauthtoken", {
        code: code,
        redirect_uri: window.location.origin + window.location.pathname,
      });
      const authData = {
        authData: {
          id: response.id,
          access_token: response.access_token,
        },
      };

      /* Check if the user already exists */
      const usrCls = Parse.Object.extend("_User");
      const usrQry = new Parse.Query(usrCls);
      usrQry.equalTo("linkedinUniqueId", String(response.id));
      await usrQry.first();
      const usrCnt = await usrQry.count();
      if (usrCnt > 0) {
        alert("Account already exists. Please login");
        redirect("/login");
      } else {
        const user = await new Parse.User().linkWith("linkedin", authData);
        user.set("linkedinUniqueId", response.id);
        user.set("name", response.localizedFirstName);
        await user.save();
        redirect("/user-info/linkedin");
        // notify("Please Complete WhatsApp Onboarding Process");
      }
    },
  };
};
